import { useEffect } from "react";

import { TAWK_PROPERTY_ID, TAWK_WIDGET_ID, tawkConfigured } from "../config/supportConfig";

// Widget de Tawk.to. Se monta SOLO dentro del área logueada (DashboardRoutes,
// detrás de PrivateRoute), así no aparece en login ni en la landing.
// Los IDs viven en config/supportConfig.js (cuenta PROPIA, no la de Voras).
const TAWK_SRC = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`;

const TawkChat = () => {
  useEffect(() => {
    if (!tawkConfigured()) return undefined; // sin cuenta configurada: no-op
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    // Inyectar el script una sola vez. En re-entradas al área logueada
    // (re-login) el script ya está cargado: solo volvemos a mostrar el widget.
    if (!document.getElementById("tawk-script")) {
      const s1 = document.createElement("script");
      s1.id = "tawk-script";
      s1.async = true;
      s1.src = TAWK_SRC;
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      document.body.appendChild(s1);
    } else if (typeof window.Tawk_API.showWidget === "function") {
      window.Tawk_API.showWidget();
    }

    // Al desmontar (logout / salir del área logueada) ocultamos el widget,
    // para que no quede flotando en login/landing.
    return () => {
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === "function") {
        window.Tawk_API.hideWidget();
      }
    };
  }, []);

  return null;
};

export default TawkChat;
